//import { ChatTrainingPage } from './pages/chat-traning/ChatTrainingPage';
import { CloneMe } from './pages/CloneMe';
import { ChatBox } from './pages/cloneme-classes/ChatBox';
import { CloneMeConsumer } from './pages/consumer/CloneMeConsumer';
//import memberstack from './pages/cloneme-classes/MemberStack';
// Adding an event listener to ensure that the document's content has loaded
document.addEventListener('DOMContentLoaded', function () {
  // Once the window has loaded completely

  // const memberstack = window.$memberstackDom;
  // const memberstack = window.$memberstackDom;
  // Requesting the next animation frame for smooth visual updates
  window.requestAnimationFrame(function () {
    // Ensure that the `Webflow` property on the window object exists, if not, initialize it as an empty array
    window.Webflow ||= [];

    // Push a new function to the `Webflow` array. This function is executed when Webflow is ready.
    window.Webflow.push(async () => {
      //  console.log('memberstack', document.querySelector('[cc-page="consumer"]'));
      // Initialize the app
      //alert('app');
      if (document.querySelector('[cc-page="chat-training"]')) {
        //  const app = new ChatTrainingPage();
        //  app.init();
        //const chatBox = new ChatBox();
        //chatBox.init();
      } else if (document.querySelector('[cc-page="consumer"]')) {
        const app = new CloneMeConsumer();
        app.init();
      } else {
        const app = new CloneMe();

        app.init();
      }

      // Add a class 'webflow-loaded' to the HTML tag using vanilla JavaScript
      document.documentElement.classList.add('webflow-loaded');
    });
  });
});
